import { storeBackendUrl } from './store';
import { API_URL_DEV, API_URL_PROD } from './constant';
import './api/apiPodcasts';
import { storePodcastCategory, storePodcast, storePodcasts } from './classes/podcast';
import { redirectTo } from './router1';
import { idPagePodcast, idPagePodcastsCategory } from './router2';
import 'svelte/store';
/**
 * Initialisation de l'URL du backend
 */
export function setBackendUrl() {
    const base_url = window.location.origin; // URL du frontend
    console.log(base_url);
    const indice127 = base_url.indexOf("/127.0.0.1");
    const indiceLocalhost = base_url.indexOf("/localhost");
    console.log(indiceLocalhost);
    if (indiceLocalhost > 0 || indice127 > 0) {
        storeBackendUrl.set(API_URL_DEV);
    }
    else {
        storeBackendUrl.set(API_URL_PROD);
    }
}
/**
 * Mise à jour d'un cookie
 * @param name
 * @param value
 * @param hours
 */
export function setCookie(name, value, hours) {
    var expires = "";
    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
/**
 * Récupération de la valeur d'un cookie
 * @param name
 * @returns
 */
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
/**
 * Suppression d'un cookie
 * @param name
 */
export function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
/**
 * redirection
 */
export function redirection() {
    const url = new URL(window.location.href);
    const splitUrl = url.href.split("/");
    let page = "";
    if (splitUrl.length > 3 && splitUrl[3].length > 0) {
        const splitPage = splitUrl[3].split("?");
        page = splitPage[0];
        const urlParams = new URLSearchParams(window.location.search);
        const params = updateStoreFromUrl(page, urlParams);
        redirectTo(page, params);
    }
}
export function updateStoreFromUrl(page, urlParams) {
    let paramUrl = "";
    if (page == idPagePodcastsCategory) {
        const categoryId = urlParams.get("id");
        if (categoryId != undefined && categoryId != "") {
            paramUrl = "?id=" + categoryId;
            storePodcastCategory.set(categoryId);
        }
    }
    else if (page == idPagePodcast) {
        const id = urlParams.get("id");
        if (id != undefined && id != "") {
            paramUrl = "?id=" + id;
            selectPodcast(id);
        }
    }
    return paramUrl;
}
function selectPodcast(idPodcast) {
    storePodcasts.subscribe((data) => {
        if (data != null && data.length > 0) {
            const podcastSelected = data.filter((item) => {
                return (item.id == idPodcast);
            })[0];
            storePodcast.set(podcastSelected);
        }
    });
}
export function scrollTopMainRoute() {
    setTimeout(() => {
        var element_to_scroll_to = document.getElementById('id_main_route');
        element_to_scroll_to.scrollTo(0, 0);
    }, 100);
}
